import { captureException } from '@sentry/react'
import { AxiosError } from 'axios'

import { displayToast } from './toast'

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) return error?.response?.data.message
  return String(error)
}

export const handleGenericError = (e?: unknown): void => {
  e && captureException(e)
  displayToast('Something went wrong, please try again', 'error')
}
